module.exports = __webpack_public_path__ + "img/icon_map_511e.c05cd90f.png";